module.exports = __webpack_public_path__ + "img/vertex-product-default.f326158d.png";